/**
 * Control panel schema — shared/ui/controls-schema.json
 */

import schemaJson from "../../../shared/ui/controls-schema.json";

export type ControlKind = "range" | "check" | "select";

export type StaticOption = { value: string; label: string };

export type OptionsFrom = "topologyRegistry" | "initRegistry" | "modelRegistry";

export type ControlDef = {
  id: string;
  kind: ControlKind;
  path: string; // sim.friendStep | render.pointSize
  glossary: string;
  label: string;
  min?: number;
  max?: number;
  step?: number;
  digits?: number;
  reset?: boolean;
  options?: StaticOption[];
  optionsFrom?: OptionsFrom;
};

export type SectionDef = {
  id: string;
  title: string;
  tier: "basic" | "advanced" | "lab";
  collapsible: boolean;
  controls: ControlDef[];
};

type SchemaFile = {
  version: number;
  sections: SectionDef[];
};

const file = schemaJson as SchemaFile;
export const CONTROL_SECTIONS: SectionDef[] = file.sections;

export function allControlDefs(): ControlDef[] {
  return CONTROL_SECTIONS.flatMap((s) => s.controls);
}

export function controlDefById(id: string): ControlDef | undefined {
  return allControlDefs().find((c) => c.id === id);
}
